/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { baselineAppStyles} from '@insticator/insticator-ui'
import { themeV2 } from 'utils/themeV2';


const baselineAppGlobalStyles = {
	'.loader': {
		'& div': {
			borderTopColor: `#000000 !important`
		}
	},
	'.name-insticator-icon': {
		backgroundImage: `url(https://static.instiengage.com/files/images/publisherportal/2.0/logos/pub_icon_color_dark.png) !important`,
	},
	'.name-insticator': {
		backgroundImage: `url(https://static.instiengage.com/files/images/publisherportal/2.0/logos/pub_gradient_dark.png) !important`,
	}
}
const baselineStyles = {
	...baselineAppStyles,
	'@global': {
		...baselineAppStyles['@global'],
		...baselineAppGlobalStyles
	}
}
/* ++++++++++ --------------- EXPORT : APP : STYLES --------------- ++++++++++ */
export default theme => ({
	...baselineStyles
});